if (!customElements.get('ck-personalization')) {
  customElements.define('ck-personalization', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.nameInput = this.querySelector('[data-ck-name]');
      this.photoInput = this.querySelector('[data-ck-photo]');
      this.preview = this.querySelector('[data-ck-preview]');
      this.image = this.querySelector('[data-ck-image]');
      this.status = this.querySelector('[data-ck-status]');
      this.form = this.closest('form');
      if (!this.form || !this.nameInput || !this.photoInput) return;
      this.nameInput.addEventListener('input', () => this.validateName(), options);
      this.photoInput.addEventListener('change', () => this.updatePhoto(), options);
      this.querySelector('[data-ck-remove]').addEventListener('click', () => {
        this.photoInput.value = '';
        this.updatePhoto();
        this.photoInput.focus();
      }, options);
      this.form.addEventListener('submit', event => {
        this.nameInput.value = this.nameInput.value.trim();
        this.validateName();
        this.validatePhoto();
        if (!this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
        }
      }, { ...options, capture: true });
      this.form.addEventListener('invalid', event => {
        if (event.target === this.nameInput) this.validateName();
        if (event.target === this.photoInput) this.validatePhoto();
      }, { ...options, capture: true });
      this.form.addEventListener('reset', () => queueMicrotask(() => {
        this.clearPreview();
        this.showError(this.nameInput, '[data-ck-name-error]', '');
        this.showError(this.photoInput, '[data-ck-photo-error]', '');
      }), options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.clearPreview();
    }
    showError(input, selector, message) {
      input.setCustomValidity(message);
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      const error = this.querySelector(selector);
      error.textContent = message;
      error.hidden = !message;
      return !message;
    }
    validateName() {
      const valid = this.nameInput.value.trim().length > 0;
      return this.showError(this.nameInput, '[data-ck-name-error]', valid ? '' : this.dataset.nameError);
    }
    validatePhoto() {
      const file = this.photoInput.files[0];
      let message = '';
      if (!file) message = this.dataset.fileError;
      else if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) message = this.dataset.fileTypeError;
      else if (file.size > 5 * 1024 * 1024) message = this.dataset.fileSizeError;
      return this.showError(this.photoInput, '[data-ck-photo-error]', message);
    }
    clearPreview() {
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
      if (this.image) this.image.removeAttribute('src');
      if (this.preview) this.preview.hidden = true;
      if (this.status) this.status.textContent = '';
    }
    updatePhoto() {
      this.clearPreview();
      if (!this.validatePhoto()) return;
      this.objectUrl = URL.createObjectURL(this.photoInput.files[0]);
      this.image.src = this.objectUrl;
      this.preview.hidden = false;
      this.status.textContent = this.dataset.fileReady;
    }
  });
}
